<app-property-option-table
        (saveOptionProperty)="saveProp($event)"
        *ngIf="boardProperties"
        [mode]="'board'"

        [targetProperties]="boardProperties"
></app-property-option-table>